import React from 'react';
import './Header.css';
import {useLocation} from "react-router-dom"; // Optional: for styling

const Header = () => {
    const location = useLocation();

    let headerText;
    if (location.pathname === '/') {
        headerText = 'Bariatric PUF Client';
    } else if (location.pathname === '/dashboard') {
        headerText = 'Bariatric PUF DOWNLOAD';
    } else if (location.pathname === '/logout') {
        headerText = 'Bariatric PUF Client';
    } else if (location.pathname === '/acsMbsaqip') {
        headerText = 'Bariatric PUF Client';
    }
    return (
        <header>
            {/*<img src={logo} className="App-logo" alt="logo"/>*/}
            {/*<h1>PUF CLIENT APPLICATION</h1>*/}
            {/*<h1>ACS NSQIP PUF Login</h1>*/}
            <div className="content-wrapper">
                <div className="div-1">
                    <div className="left-image">
                        {/*<img src="../images/NSQIPAdult.png" alt=""/>*/}
                    </div>
                    <div className="middle-text">
                        <span className="middle-text-span1">ACS MBSAQIP</span><br/>
                        <span className="middle-text-span2">{headerText}</span>
                    </div>
                    <div className="right-image">
                        {/*<img src="../images/ACSLogo.png" alt=""/>*/}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;